export default __webpack_public_path__ + "static/media/sistemaVexadoLogo.7efba5b2.png";